import React from 'react';
import {
    Tooltip as AntdTooltip,
    type TooltipProps as AntdTooltipProps,
} from 'antd';
import type { TooltipRef } from 'antd/es/tooltip';

export type TooltipProps = AntdTooltipProps;

const Tooltip = React.forwardRef<TooltipRef, TooltipProps>((props, ref) => (
    <AntdTooltip ref={ref} {...props} />
));

Tooltip.displayName = 'Tooltip';

export { AntdTooltip };
export type { TooltipRef };
export default Tooltip;
